﻿import { IComponent, Component, Inject, Input, Output } from "@fiqas/angular-utils";
import { FIQAssist  } from "../../app";
import { Application } from "../application"
import { IDisposable } from "../../interfaces/general";
import { IsProcessingService } from "../../services/isProcessingService";

@Component({
    module: FIQAssist,
    selector: "other",
    templateUrl: "views/other.html",
    require: {
        application: "^application",
    }
})
class Other implements IComponent {
    @Input() private $router: ng.Router;
    public application: Application;

    constructor(
        @Inject() private isProcessingService: IsProcessingService,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$q') private $q: ng.IQService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService

    ) {
    }

    //    private selectedCustomers;

    $onInit() {
        this.Title = "OTHER_OPTIONS";
        this.activeMenuItem = 'other';
    }

    $onDestroy() {
        this.activeMenuItem = '';
    }

    public Title: string = '';
    public Title2: string = '';
    public activeMenuItem: string;
}